import { CommunicationBaseService } from '../gen/service/communication-base-service'

export class CommunicationService extends CommunicationBaseService {}
